import { useEffect } from 'react';

import {
	refreshVipTicketBalance,
	useVipTicketPlayerId,
} from '../../utils/hooks/useVipTicketBalance';

/**
 * Reads the VIP Ticket wallet as soon as a player is known, so the Bonuses badge and the VIP
 * Arcade gate already hold a balance on their first open instead of waiting on the slow wallet
 * read there. The screens refresh it again on focus.
 */
const VipTicketBalanceHost = () => {
	const playerId = useVipTicketPlayerId();

	useEffect(() => {
		if (playerId) refreshVipTicketBalance(playerId);
	}, [playerId]);

	return null;
};

export default VipTicketBalanceHost;
